import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { PRODUCTS } from '../data/content.js'

export default function Assortiment() {
  const { t } = useTranslation()

  return (
    <section className="section">
      <div className="container">
        <p className="eyebrow">Almus</p>
        <h1 className="section-title">{t('products.title')}</h1>
        <div className="grid-3">
          {PRODUCTS.map((product) => {
            const info = t(`productItems.${product.id}`, { returnObjects: true })
            return (
              <Link key={product.id} to={`/assortiment/${product.slug}`} className="card">
                <h3>{info.title}</h3>
                <p>{info.desc}</p>
                <span className="card-link">{t('products.learnMore')} →</span>
              </Link>
            )
          })}
        </div>
      </div>
    </section>
  )
}